import {fetch} from "utils/dataAccess";

export async function getStockAlert(productId) {
    const response = await fetch(`/products/${productId}/stock_alerts_summary`);

    return await response.json();
}
